import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import useUserMessaging from './useUserMessaging';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useLanguageSettings } from '../Settings/useLanguageSettings';
import { setTranslateLanguageContent } from '../../store/userMessaging/actions';

export default function AlertDialog(props) {
  const dispatch = useDispatch();
  const { isOpen, handleClose, message, buttons } = useUserMessaging(props);
  const severity = (message.severity || 'info').toLowerCase();
  const CustomContent = message.customContent;
  const [showDefaultButtons, setShowDefaultButtons] = useState(true);
  const { languageContent, getLanguageContent } = useLanguageSettings();

  useEffect(() => {
      if (languageContent) {
        dispatch(setTranslateLanguageContent(getLanguageContent("errors")))
      }
    }, [languageContent]);

  let GenericMessageDialogContent = props => {
    const { severity, message } = props;
    return (
      <>
        <Alert severity={severity}>
          <AlertTitle>{message.title}</AlertTitle>
        </Alert>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message.instructions}
          </DialogContentText>
        </DialogContent>
      </>
    );
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        maxWidth={message.size || 'sm'}
        disableBackdropClick={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        {!CustomContent && (message?.title || message?.instructions) && (
          <GenericMessageDialogContent severity={severity} message={message} />
        )}

        {CustomContent && (
          <CustomContent
            handleClose={handleClose}
            setShowDefaultButtons={setShowDefaultButtons}
            severity={severity}
            message={message}
            {...message.props}
          />
        )}

        {showDefaultButtons && buttons.length > 0 && (
          <DialogActions>
            {buttons.map((b, i) => (
              <Button key={i} onClick={b.onClick}>
                {b.title}
              </Button>
            ))}
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
